import "./search.scss";
import { useMemo, useState } from "react";
import { getValue } from "@utils/lodash";
import ReactTooltip from "react-tooltip";
import { debounceSearch } from "@_common/text-helper";

export default function Search(props: any) {
  const [searchText, setSearchText] = useState("");
  const debouncedSearch = useMemo(
    () => debounceSearch(props.handleChangeSearch, 500),
    []
  );

  const handleChangeSearch = (e: any) => {
    setSearchText(e.target.value);
    debouncedSearch(e);
  };

  return (
    <section className="common-search-wrapper__filter d-flex align-items-center">
      {props.showSearchTextbox && (
        <>
          <div className="common-search-wrapper__filter-form-group form-group m-0">
            <input
              type="text"
              placeholder={props.placeholder ? props.placeholder : "Search"}
              className="common-search-wrapper__filter-search-input"
              value={searchText}
              onChange={handleChangeSearch}
            />
            <img
              src="/images/search.svg"
              className="img-fluid common-search-wrapper__filter-input-image"
            />

            <img
              src="/images/close-black.svg"
              className="img-fluid common-search-wrapper__filter-image-close"
              onClick={() => {
                props.toggleSearchClose();
              }}
            />
          </div>
        </>
      )}

      <ReactTooltip id="subHeaderSearch" effect="solid" place="bottom">
        Search
      </ReactTooltip>
      <div
        className="common-search-wrapper__filter-container cursor-pointer icons-btn"
        onClick={() => {
          props.toggleSearchClose();
        }}
        data-tip
        data-for="subHeaderSearch"
      >
        <div className="d-flex">
          <img
            src="/images/search.svg"
            className="img-fluid common-search-wrapper__filter-image"
          />
        </div>
        {/* <h6 className="common-search-wrapper__filter-title">
					{props.searchText || "SEARCH"}
				</h6> */}
      </div>
    </section>
  );
}
